// The user pool's password policy (template.yaml, PasswordPolicy): minimum 8
// characters with an uppercase letter, a lowercase letter, a number and a symbol.
// One statement of it, shared by the signup form, AuthContext and errorHandlers.

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_POLICY_MESSAGE =
  'Password must be at least 8 characters and include an uppercase letter, a lowercase letter, a number and a symbol.';

/**
 * Null when the password meets the pool's policy. Cognito stays the authority:
 * its accepted symbol set is narrower than "not alphanumeric", so a rare
 * password can pass here and still fail server-side with InvalidPasswordException.
 */
export function passwordPolicyError(password: string): string | null {
  const checks = [
    password.length >= PASSWORD_MIN_LENGTH,
    /[A-Z]/.test(password),
    /[a-z]/.test(password),
    /[0-9]/.test(password),
    /[^A-Za-z0-9]/.test(password),
  ];
  return checks.every(Boolean) ? null : PASSWORD_POLICY_MESSAGE;
}
